import React from 'react';
import { bool, arrayOf, string } from 'prop-types';
import styled from 'styled-components';

import Legend from 'components/Legend/Legend';

const StyledLegend = styled(Legend)`
  flex: 1 1 auto;
  align-items: end;
  margin-top: 1em;
  margin-right: 1em;
`;

export function LineChartLegend({ showReference, groupsWithData, groupIds }) {
  return (
    <StyledLegend
      showReference={showReference}
      groupsWithData={groupsWithData}
      groupIds={groupIds}
    />
  );
}

LineChartLegend.propTypes = {
  showReference: bool,
  groupsWithData: arrayOf(string),
  groupIds: arrayOf(string),
};

export default LineChartLegend;



// WEBPACK FOOTER //
// ./src/components/LineChartLegend/LineChartLegend.js